import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

const LoadingPage = (props) => {
  const { classes } = props;
  return (
      <div style={{ display: 'flex', height: '100vh', width: '100vw', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress className={classes.progress} size={50} />
      </div>
)};

export default withStyles(styles)(LoadingPage);



// WEBPACK FOOTER //
// ./src/components/loading/LoadingPage.js